export const ventrisConfig = {
    url: 'https://app.ventrislearning.com',
    showSsoLogin: process.env.REACT_APP_SHOW_SSO_LOGIN !== 'false'
  };
